import { FC } from 'react';
import { OrderResponse, OrderServiceTechnician } from '../../../api/orders';

interface SchedulerItemBlockProps {
    order: OrderResponse;
    assignment: OrderServiceTechnician;
    view: 'bay' | 'technician' | 'car';
}

const SchedulerItemBlock: FC<SchedulerItemBlockProps> = ({ order, assignment, view }) => {
    const isCompleted = assignment.completed;
    const technician = assignment.technician;

    return (
        <div className={`flex flex-col gap-0.5 p-1.5 rounded-lg border shadow-sm transition-all duration-200 hover:shadow-md ${isCompleted ? 'bg-emerald-50/50 border-emerald-200' : 'bg-slate-50 border-slate-200'}`}>
            <div className="flex items-center justify-between gap-1">
                <div className="flex flex-col min-w-0">
                    <span className="text-[9px] font-bold uppercase tracking-wider text-slate-400">
                        SO: {order.orderNumber}
                    </span>
                    <span className="text-[10px] font-semibold text-slate-700 truncate leading-tight" title={assignment.orderItem?.description || 'Service'}>
                        {assignment.orderItem?.description || 'Service'}
                    </span>
                </div>
                {isCompleted && (
                    <span className="shrink-0 inline-flex items-center rounded-full bg-emerald-100 px-1.5 py-0.5 text-[8px] font-medium text-emerald-700">
                        Comp
                    </span>
                )}
            </div>

            <div className="flex flex-col">
                <p className="text-[10px] font-bold text-slate-800 leading-tight">
                    {order.customerVehicle?.vehicleRegistrationNumber || 'N/A'}
                </p>

                <p className="text-[9px] text-slate-500 leading-tight truncate">
                    {order.customerVehicle?.vehicleBrand?.name || ''} {order.customerVehicle?.vehicleModel?.name || ''}
                </p>
            </div>

            <div className="mt-0.5 flex items-center justify-between gap-1 border-t border-slate-200/60 pt-1">
                <div className="flex items-center gap-1 min-w-0">
                    {view !== 'technician' && technician && (
                        <div className="flex items-center gap-1 overflow-hidden">
                            <div className="h-4 w-4 rounded-full bg-primary/10 flex items-center justify-center text-[8px] font-bold text-primary shrink-0 overflow-hidden border border-primary/20">
                                {technician.firstName?.[0] || technician.username?.[0] || 'T'}
                            </div>
                            <span className="truncate text-[9px] font-medium text-slate-600">
                                {technician.firstName || technician.username}
                            </span>
                        </div>
                    )}
                    {view === 'technician' && assignment.bayId && (
                        <div className="flex items-center gap-1 text-[9px] font-medium text-primary bg-primary/5 px-1.5 py-0.5 rounded-full border border-primary/10">
                            <span className="text-[8px] uppercase tracking-tighter opacity-70">Bay:</span>
                            {order.serviceTechnicians?.find(a => a.id === assignment.id)?.bay?.name || 'Assigned'}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SchedulerItemBlock;
